import { useTrackView } from 'src/app/shared/hooks/tracking';

export function useProfileCardViewTracker() {
	useTrackView('dm_profile_profile_card_view');
}
